export const JURISTAI_INTERNAL_EMAIL_DOMAIN = "@juristai.org";

const INTERNAL_EMAIL_DOMAINS = [JURISTAI_INTERNAL_EMAIL_DOMAIN, "@nougat.law"];
const PERMISSION_TEST_EMAIL = /^[^@]+\+p\d+@(?:juristai\.org|nougat\.law)$/;

const normalizeEmail = (value) =>
  typeof value === "string" ? value.trim().toLowerCase() : "";

export const isJuristaiInternalEmail = (email) =>
  INTERNAL_EMAIL_DOMAINS.some((domain) => normalizeEmail(email).endsWith(domain)) &&
  !PERMISSION_TEST_EMAIL.test(normalizeEmail(email));

export const canAccessInternalOps = (user) =>
  isJuristaiInternalEmail(user?.email);
